import { Typography, Box, Paper, Stack, Grid } from "@mui/material";

const tryParseJson = (value) => {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};


export default function VersusSettings({ rawData }) {
  const parsed = tryParseJson(rawData);

  if (!parsed || typeof parsed !== "object") {
    return (
      <Typography color="error" variant="body2">
        Invalid or empty Versus settings JSON
      </Typography>
    );
  }
  console.log("Versus Settings:", rawData.gameModes);
  return (
    <Stack spacing={1} sx={{ p: 0, flex: 1, justifyContent: 'center' }}>
      <Grid container>
        {rawData.gameModes.map((row, index) => (
          <Grid item xs={2} key={index} sx={{ p: 1 }}>
            <Paper sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              height: '100%',
              py: 2,
              px: 1,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              backgroundColor: 'background.paper',
              '&:hover': {
                borderColor: 'primary.main',
                backgroundColor: 'action.hover',
              },
            }}>
              <Typography variant="subtitle1" sx={{
                fontSize: '0.7rem',
                fontWeight: 700,
                letterSpacing: 0.5,
                textAlign: 'center',
                textTransform: 'uppercase',
                color: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                {row.title}
              </Typography>

              <Box sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
              }}>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 0.5,

                }}>
                  <Typography variant="body2" sx={{
                    color: 'text.secondary',
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: 0.3,
                    flex: 1,
                  }}>
                    Entry:
                  </Typography>
                  <Typography variant="subtitle2" sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    fontSize: '0.8rem',
                    textAlign: 'right',
                    flex: 1,
                  }}>
                    {row ? `${String(row.entryFee)}` : "N/A"}
                  </Typography>
                </Box>

                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 0.5,
                }}>
                  <Typography variant="body2" sx={{
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: 0.3,
                    color: 'text.secondary',
                    flex: 1,
                  }}>
                    Winnings:
                  </Typography>
                  <Typography variant="subtitle2" sx={{
                    fontWeight: 700,
                    color: 'success.dark',
                    fontSize: '0.8rem',
                    textAlign: 'right',
                    flex: 1,
                  }}>
                    {row ? `${String(row.winnings)}` : "N/A"}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Stack >
  )
}
